/* tslint:disable */
/* eslint-disable */
/**
 * C4 Links Collab Catman API
 * API documentation for C4 Links Collab Catman
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Defines the type of search to be performed on filter definition values
 */
export var FilterDefinitionValueSearchType;
(function (FilterDefinitionValueSearchType) {
  FilterDefinitionValueSearchType['CONTAINS'] = 'contains';
  FilterDefinitionValueSearchType['STARTS_WITH'] = 'startsWith';
  FilterDefinitionValueSearchType['ENDS_WITH'] = 'endsWith';
  FilterDefinitionValueSearchType['MULTISELECT'] = 'multiselect';
})(FilterDefinitionValueSearchType || (FilterDefinitionValueSearchType = {}));
